import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { AuthenticationService } from 'app/services';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ActivitiesSearchComponent } from './activities-search/activities-search.component';
@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DashboardComponent {
    currentUser: any;
    currentAgency: any;
    searchDialogRef: any;
    timeLineData: any;
    trialEndDaysCount: number = 0;
    subRouts: { label: string; path: string; index: number }[];
    private _unsubscribeAll: Subject<any>;
    constructor(
        private router: Router,
        private _authenticationService: AuthenticationService,
        private _matDialog: MatDialog
    ) {
        this.currentUser = this._authenticationService.currentUserValue;
        this.currentAgency = this._authenticationService.currentAgencyValue;
        if (this.currentAgency?.status === "trial period" && this.currentAgency?.trial_to) {
            const now = new Date();
            const endDate = new Date(this.currentAgency?.trial_to);
            this.trialEndDaysCount = this.dateDiffInDays(now, endDate);
        }

        if (this.currentUser.user_role === 'agent_portal') {
            this.subRouts = [
                {
                    label: 'Dashboard',
                    path: './home-cb',
                    index: 0,
                },
                {
                    label: 'Calendar',
                    path: './calendar',
                    index: 1,
                },
                {
                    label: 'Mailbox',
                    path: './mail',
                    index: 3,
                },
                // {
                //     label: 'Reports',
                //     path: './reports',
                //     index: 4
                // },
            ];
            this.router.navigate(['/dashboard/home-cb']);
        } else {
            this.subRouts = [
                {
                    label: 'Dashboard',
                    path: './home',
                    index: 0,
                },
                {
                    label: 'Calendar',
                    path: './calendar',
                    index: 1,
                },
                {
                    label: 'Activities',
                    path: './activities/active',
                    index: 2,
                },
                {
                    label: 'Mailbox',
                    path: './mail',
                    index: 3,
                },
                // {
                //     label: 'Reports',
                //     path: './reports',
                //     index: 4
                // },
                {
                    label: 'My sequences',
                    path: './sequences',
                    index: 5,
                },
            ];
        }
        // {
        //     this.currentUser.user_role === 'agent_portal'
        //         ? (this.subRouts = [
        //               {
        //                   label: 'Dashboard',
        //                   path: './home-cb',
        //                   index: 0,
        //               },
        //               {
        //                   label: 'Calendar',
        //                   path: './calendar',
        //                   index: 1,
        //               },
        //               {
        //                   label: 'Mailbox',
        //                   path: './mail',
        //                   index: 3,
        //               },
        //               // {
        //               //     label: 'Reports',
        //               //     path: './reports',
        //               //     index: 4
        //               // },
        //           ])
        //         : (this.subRouts = [
        //               {
        //                   label: 'Dashboard',
        //                   path: './home',
        //                   index: 0,
        //               },
        //               {
        //                   label: 'Calendar',
        //                   path: './calendar',
        //                   index: 1,
        //               },
        //               {
        //                   label: 'Activities',
        //                   path: './activities/active',
        //                   index: 2,
        //               },
        //               {
        //                   label: 'Mailbox',
        //                   path: './mail',
        //                   index: 3,
        //               },
        //               // {
        //               //     label: 'Reports',
        //               //     path: './reports',
        //               //     index: 4
        //               // },
        //               {
        //                   label: 'My sequences',
        //                   path: './sequences',
        //                   index: 5,
        //               },
        //           ]);
        // }
    }

    ngOnInit(): void {
        if(this.currentUser && this.currentUser.user_dashboard_view && !this.currentUser.user_dashboard_view.includes('dashboard/home')){
            this.currentUser.user_dashboard_view === "activitiesDashboard" ? this.router.navigate(['dashboard/home']) : this.router.navigate([`${this.currentUser.user_dashboard_view}`]);
        }
    }

    searchData(): any {
        this.searchDialogRef = this._matDialog.open(ActivitiesSearchComponent, {
            panelClass: 'event-form-dialog',
            disableClose: false,
        });
        this.searchDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response) {
                    // this.filter = _.pickBy(response.value, _.identity);
                    // this.filter.grid = false;
                    // this.filter.status_not = 'inactive';
                    // this.dataReload.setValue(null);
                }
            });
    }

    dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;

        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    // openMeetingsAndTours(): void {
    //     // this.timeLineData = property;
    //     this._fuseSidebarService.getSidebar('propertyIndexTimeLine').toggleOpen();
    // }
}
